import { render, staticRenderFns } from "./PageEducatorInstitutionClassroomRead.vue?vue&type=template&id=dcd39558&scoped=true&"
import script from "./PageEducatorInstitutionClassroomRead.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionClassroomRead.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionClassroomRead.vue?vue&type=style&index=0&id=dcd39558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd39558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
